import * as _ from 'lodash'
import valueFilters from '../valueFilters';
import validator from '../validator';
import modelFactory, { IModel } from '../modelFactory';
import model from './model';

type NoteType = 'contract-for-operations' | 'contract-for-installer' | 'contract-subtrade' | 'contract-customer-pricing';

const NOTE_TYPES: Record<string, NoteType> = {
	CONTRACT_FOR_OPERATIONS: 'contract-for-operations',
	CONTRACT_FOR_INSTALLER: 'contract-for-installer',
	CONTRACT_SUBTRADE: 'contract-subtrade',
	CONTRACT_CUSTOMER_PRICING: 'contract-customer-pricing'
}

export interface IJobCostNote extends IModel {
	jobCostKey?: string;
	changeOrderKey?: string;
	content?: string;
	type?: NoteType;
	relatedKey?: string;
}

const jobCostNoteFactory = Object.assign(modelFactory.createFactory<IJobCostNote>('JobCostNote', _.assign({}, model, {
	jobCostKey: {
		setFilters: valueFilters.clean
	},
	changeOrderKey: {
		setFilters: valueFilters.clean
	},
	content: {
		rules: validator.required()
	},
	type: {
		setFilters: valueFilters.clean
	},
	relatedKey: {
		setFilters: valueFilters.clean
	}
})), {
	NOTE_TYPES
});

export default jobCostNoteFactory;